// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"E4-z"};